import { Navigate, useLocation } from 'react-router-dom';
import { IP_ANCHOR_PATH, legacyIpAnchorTarget } from '../../ipAnchor/routes';

/** Sends a legacy /ip-anchor/... address to the same place under /ipanchor. */
export default function LegacyIpAnchorRedirect() {
  const location = useLocation();
  const target = legacyIpAnchorTarget(location.pathname, location.search, location.hash) ?? IP_ANCHOR_PATH;
  return <Navigate to={target} replace state={location.state} />;
}
